export enum OperationExecutorType {
  ARTIFACT = 'artifact',
  FIELD_VALUE = 'field_value',
  REPORT = 'report',
}
